import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ContactUsModalComponent } from '../contact-modal/contact-modal.component';

type StepState = "default" | "active" | "completed";
type LanguageOption = { label: string; value: string };

@Component({
  selector: "app-info-screen",
  templateUrl: "./info-screen.component.html",
  styleUrl: "./info-screen.component.scss",
})
export class InfoScreenComponent implements OnInit {
  @Input() type: "info" | "consent-signed" = "info";
  @Input() title: string = "You are one step closer to";
  @Input() highlightedText: string = "saving a life.";
  @Input() description: string =
    "The kidney donor evaluation process is designed to:";
  @Input() listItems: string[] = [];
  @Input() buttonText: string = "Get Started";
  @Input() contactLink: string | null = "/contact"; // Set null if you don't want the contact link
  @Input() steps: { label: string; state: StepState }[] = [
    { label: "Initial Questionnaire", state: "default" },
    { label: "Comprehensive Questionnaire", state: "default" },
    { label: "Living Kidney Donor Consent", state: "default" },
    { label: "Consultation & Evaluation", state: "default" },
  ];
  @Input() email: string = "";
  @Input() languageLabel = "";
  @Input() languageHelpText = "";
  @Input() languageOptions: LanguageOption[] = [];
  @Input() selectedLanguage = "";
  showExploreJourney: boolean = false;

  @Output() buttonClicked = new EventEmitter<void>();
  @Output() languageChanged = new EventEmitter<string>();

  onClick() {
    this.buttonClicked.emit();
  }

  onLanguageChange(locale: string) {
    this.languageChanged.emit(locale);
  }

  get selectedLanguageLabel(): string {
    return (
      this.languageOptions.find(
        (language) => language.value === this.selectedLanguage
      )?.label || "Select language"
    );
  }

  constructor(private modalService: NgbModal,) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.showExploreJourney = true;
    }, 30000);
  }
   
  openContactModal(): NgbModalRef {
    return this.modalService.open(ContactUsModalComponent, {
      centered: true,
      backdrop: "static",
    });
  }
  
}
